import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExclamationTriangle } from '@fortawesome/free-solid-svg-icons';

export const ExclamationTriangleIcon = () => (
    <FontAwesomeIcon className="warning-icon" icon={faExclamationTriangle} />
)

export default ExclamationTriangleIcon;



// WEBPACK FOOTER //
// ./src/components/icons/ExclamationTriangleIcon.js